/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { AccountLimitType } from './AccountLimitType';

export type AccountLimitBase = {
    /**
     * Indicates whether the limit is unlimited or defined with a specific amount.
     */
    variant: AccountLimitBase.variant;
    type: AccountLimitType;
};

export namespace AccountLimitBase {

    /**
     * Indicates whether the limit is unlimited or defined with a specific amount.
     */
    export enum variant {
        LIMITED = 'LIMITED',
        UNLIMITED = 'UNLIMITED',
        UNKNOWN = 'UNKNOWN',
    }


}

